import { Injectable } from "@angular/core";
import { forkJoin, take } from "rxjs";
import { storage } from "@gtmhub/core/storage";
import { ICustomFieldsStoreState } from "@gtmhub/customFields/redux/custom-field-reducer";
import { EnvironmentService } from "@gtmhub/env";
import { reduxStoreContainer } from "@gtmhub/state-management/state-management.module";
import { AccountResolverService } from "@gtmhub/state/account-resolver-service";
import { DestroyService } from "@webapp/core/util/services/destroy.service";
import { PluginStateService } from "@webapp/plugins/components/plugin/services/plugin-state.service";
import { PluginService } from "@webapp/plugins/components/plugin/services/plugin.service";
import { GetRequest } from "@webapp/plugins/plugins.models";
import { PluginsFacade } from "@webapp/plugins/services/plugins-facade.service";

@Injectable()
export class PluginCommonService extends PluginService {
  constructor(
    private accountResolverService: AccountResolverService,
    private environmentService: EnvironmentService,
    private pluginsFacade: PluginsFacade,
    pluginStateService: PluginStateService,
    destroy$: DestroyService
  ) {
    super(pluginStateService, destroy$);
  }

  public getDc(type: string): void {
    const apiEndpoint = this.environmentService.getApiEndpoint();
    let dc: string;

    if (apiEndpoint.indexOf(".staging") > -1) {
      dc = "staging";
    } else {
      dc = this.environmentService.getDC();
    }

    this.postMessage(dc, type);
  }

  public getSetting(type: string, data: GetRequest): void {
    this.pluginsFacade
      .getPluginStore$({ pluginId: this.plugin.pluginId, key: data.id })
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.postMessage(response, type);
        },
        error: (error) => {
          this.postMessage(this.pluginsFacade.transformHttpError(error), type);
        },
      });
  }

  public getSettings(type: string): void {
    const plugins$ = this.plugin.uiPlugin.pluginSettings
      .filter((setting) => setting.key)
      .map((setting) => this.pluginsFacade.getPluginStore$({ pluginId: this.plugin.pluginId, key: setting.key }));

    forkJoin(plugins$)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.postMessage(response, type);
        },
        error: (error) => {
          this.postMessage(this.pluginsFacade.transformHttpError(error), type);
        },
      });
  }

  public getAccountId(type: string): void {
    this.postMessage(storage.get("accountId"), type);
  }

  public getAccountSettings(type: string): void {
    this.postMessage(this.accountResolverService.getAccountData(), type);
  }

  public getAccountUrl(type: string): void {
    this.postMessage({ accountUrl: window.location.origin }, type);
  }

  public getCustomFields(type: string): void {
    const customFields = reduxStoreContainer.reduxStore.getState<ICustomFieldsStoreState>().customFields.map;
    this.postMessage(customFields, type);
  }

  public resize(type: string, data: { payload: { height: number } }): void {
    const { height } = data.payload;

    const plugin = document.getElementById(`${this.accessPoint}-${this.plugin.uiPlugin.src}`);
    plugin.style.height = `${height}px`;

    this.postMessage("Plugin has been resized successfully", type);
  }
}
